(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9-]/g, '');
    cents = Number(cents || 0);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var nums = (Math.abs(number) / 100.0).toFixed(precision).split('.');
      var dollars = nums[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return (number < 0 ? '-' : '') + dollars + (nums[1] ? decimal + nums[1] : '');
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  class BuyTogether extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.moneyFormat = this.getAttribute('data-money-format') || '';
      this.formId = this.getAttribute('data-product-form-id') || '';
      this.percentTemplate = this.getAttribute('data-percent-template') || '##% off';

      this.querySelectorAll('[data-buy-together-item]').forEach((item) => {
        this.setupItem(item);
      });
    }

    setupItem(item) {
      var jsonEl = item.querySelector('[data-buy-together-variants]');
      var variants = [];
      try {
        variants = JSON.parse(jsonEl ? jsonEl.textContent : '[]');
      } catch (err) {
        variants = [];
      }
      item._variants = variants;

      var addBtn = item.querySelector('[data-buy-together-add]');

      var toggle = item.querySelector('[data-buy-together-toggle]');
      if (toggle) {
        toggle.addEventListener('click', () => this.toggleItem(item));
      }

      item.querySelectorAll('[data-buy-together-option]').forEach((group) => {
        group.addEventListener('change', () => this.syncItem(item));
      });

      if (addBtn) {
        addBtn.addEventListener('click', () => this.addBundle(item, addBtn));
      }

      // 注意：初始化时不调用 syncItem！
      // Liquid + Transcy 已经处理好了默认变体的价格/图片/按钮状态，
      // 如果这里主动 sync，会把 Transcy 已包装好的 .money 节点 replaceWith 掉，
      // 导致页面初始渲染和后续货币转换异常。
      // 只在用户操作（换选项、展开面板）时才触发 syncItem。
    }

    toggleItem(item) {
      var willOpen = !item.classList.contains('is-open');
      this.querySelectorAll('[data-buy-together-item]').forEach((el) => {
        var isTarget = willOpen && el === item;
        el.classList.toggle('is-open', isTarget);
        var btn = el.querySelector('[data-buy-together-toggle]');
        var panel = el.querySelector('[data-buy-together-panel]');
        if (btn) btn.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        if (panel) panel.hidden = !isTarget;
      });
    }

    selectedOptions(item) {
      var selected = {};
      item.querySelectorAll('[data-buy-together-option]').forEach((group) => {
        var checked = group.querySelector('input:checked');
        var position = Number(group.getAttribute('data-option-position') || 0);
        var value = checked ? String(checked.value || '').trim() : '';
        if (position >= 1 && position <= 3) selected[position] = value;
        var label = group.querySelector('[data-buy-together-option-value]');
        if (label && checked) label.textContent = checked.value;
      });
      return selected;
    }

    findVariant(item) {
      var variants = item._variants || [];
      var selected = this.selectedOptions(item);
      var positions = Object.keys(selected);
      if (!positions.length) {
        return variants.find((variant) => variant.available) || variants[0] || null;
      }
      return (
        variants.find((variant) => {
          return positions.every((position) => {
            var chosen = String(selected[position] || '').trim().toLowerCase();
            var actual = String(variant['option' + position] || '').trim().toLowerCase();
            return chosen === actual;
          });
        }) ||
        variants[0] ||
        null
      );
    }

    updateImage(item, url) {
      if (!url) return;
      var imageEl = item.querySelector('[data-buy-together-image], img.buy-together__image');
      var media = item.querySelector('.buy-together__media');
      if (imageEl && imageEl.tagName === 'IMG') {
        imageEl.src = url;
        imageEl.removeAttribute('srcset');
        imageEl.removeAttribute('sizes');
        return;
      }
      if (!media) return;
      var img = document.createElement('img');
      img.className = 'buy-together__image';
      img.setAttribute('data-buy-together-image', '');
      img.src = url;
      img.width = 80;
      img.height = 80;
      img.alt = '';
      media.replaceChildren(img);
    }

    syncMoneyElement(el, cents) {
      if (!el) return;
      if (window.themeMoneyDom?.sync) {
        window.themeMoneyDom.sync(el, {
          cents: cents,
          moneyFormat: this.moneyFormat,
        });
        return;
      }
      // 兜底（themeMoneyDom 未加载）
      var wrapper = el.firstElementChild;
      var innerHTML = '<span class="money">' + formatMoney(cents, this.moneyFormat) + '</span>';
      if (wrapper) {
        wrapper.innerHTML = innerHTML;
      } else {
        el.innerHTML = innerHTML;
      }
    }

    syncItem(item) {
      var variant = this.findVariant(item);
      var priceEl = item.querySelector('[data-buy-together-price]');
      var compareEl = item.querySelector('[data-buy-together-compare]');
      var saveEl = item.querySelector('[data-buy-together-save]');
      var addBtn = item.querySelector('[data-buy-together-add]');
      var addLabel = item.querySelector('[data-buy-together-add-label]');

      item._variant = variant;

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        return;
      }

      this.syncMoneyElement(priceEl, variant.price);

      var showCompare = Number(variant.compare) > Number(variant.price);
      if (compareEl) {
        if (showCompare) {
          this.syncMoneyElement(compareEl, variant.compare);
        } else {
          compareEl.innerHTML = '';
        }
        compareEl.classList.toggle('is-hidden', !showCompare);
      }
      if (saveEl) {
        var percent = showCompare
          ? Math.round(((Number(variant.compare) - Number(variant.price)) * 100) / Number(variant.compare))
          : 0;
        saveEl.textContent = percent > 0 ? this.percentTemplate.replace('##', String(percent)) : '';
        saveEl.classList.toggle('is-hidden', percent <= 0);
      }

      item.querySelectorAll('[data-buy-together-option] .color-swatch').forEach((swatch) => {
        var label = swatch.closest('label');
        var input = label ? label.previousElementSibling : null;
        swatch.classList.toggle('selected-swatch', !!(input && input.checked));
      });

      this.updateImage(item, variant.image);

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available
            ? addBtn.getAttribute('data-add-label') || addLabel.textContent
            : addBtn.getAttribute('data-sold-out-label') || addLabel.textContent;
        }
      }
    }

    mainVariantId() {
      var form = this.formId ? document.getElementById(this.formId) : null;
      if (!form) form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return '';
      var input = form.querySelector('[name="id"]');
      return input ? String(input.value || '') : '';
    }

    setError(item, message) {
      var errorEl = item.querySelector('[data-buy-together-error]');
      if (!errorEl) return;
      if (message) {
        errorEl.hidden = false;
        errorEl.textContent = message;
      } else {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    addBundle(item, addBtn) {
      if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
      var pair = item._variant || this.findVariant(item);
      var mainId = this.mainVariantId();
      if (!pair || !pair.id || !mainId) {
        this.setError(item, addBtn.getAttribute('data-error') || '');
        return;
      }
      if (!pair.available) return;

      this.setError(item, '');
      var spinner = addBtn.querySelector('.loading__spinner');
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      var payload = {
        items: [
          { id: Number(mainId), quantity: 1 },
          { id: Number(pair.id), quantity: 1 },
        ],
      };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',');
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }

      fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message || 'Add to cart failed');
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'buy-together',
              cartData: response,
            });
          }
          if (!cart) {
            window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
            return;
          }
          if (typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(response);
            return;
          }
          if (typeof cart.open === 'function') cart.open();
        })
        .catch((err) => {
          this.setError(item, (err && err.message) || addBtn.getAttribute('data-error') || '');
        })
        .finally(() => {
          addBtn.classList.remove('loading');
          addBtn.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }
  }

  if (!customElements.get('buy-together')) {
    customElements.define('buy-together', BuyTogether);
  }
})();
